import { useState } from 'react'
import showToast from '../../Components/Common/SweetAlert/ToastAlert'
import { fetchAssignedTaskDetails, updateArchiveTask } from '../../redux/task/actions'
import { AppDispatch, useAppDispatch, useAppSelector } from '../../redux/store'
import { selectUserTeamMemberInfo } from '../../redux/auth/selector'

interface useArchivedTaskProps {
  id: number
}

const useArchiveTask = ({ id }: useArchivedTaskProps) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const dispatch: AppDispatch = useAppDispatch()

  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)
  const teamMemberDetailsPayload = {
    teamMemberEmail: teamMemberDetails.email,
    teamMemberWorkdayId: teamMemberDetails.workdayId,
  }

  const archiveTask = async () => {
    setLoading(true)
    setError(null)

    try {
      const updatedEventData = {
        isArchived: true,
        updatedBy: {
          email: teamMemberDetails.email,
          workdayId: teamMemberDetails.workdayId,
        },
      }

      await dispatch(updateArchiveTask({ id: id, ...updatedEventData })).unwrap()
      showToast('success', 'Task archived successfully!')
    } catch (error) {
      showToast('error', 'Error updating task archive status')
      console.error('Error updating task archive status:', error)
      setError('An error occurred while updating the archive status.')
    } finally {
      await dispatch(fetchAssignedTaskDetails(teamMemberDetailsPayload)).unwrap()
      setLoading(false)
    }
  }
  return { archiveTask, loading, error }
}

export default useArchiveTask
